export default __webpack_public_path__ + "static/KeywordResearch_02_03@2x-a08686ea107020064b2bec0779b48b2c.png";